export default __webpack_public_path__ + "static/media/avatar_cow1.3ed430b2.mp3";